class CartDrawer extends HTMLElement {
  constructor() {
    super();
    console.log('🛒 CartDrawer constructor called');

    this.drawer = this; // The custom element itself is the drawer
    this.overlay = document.querySelector('#cart-drawer-overlay');
    this.openButton = document.querySelector('[data-cart-drawer-toggle]');
    this.closeButton = this.querySelector('.cart-drawer__close');
    this.cartItems = this.querySelector('#cart-drawer-items') || this.querySelector('.cart-drawer__items');
    this.cartForm = this.querySelector('.cart-drawer__form');
    this.cartNote = this.querySelector('#cart-drawer-note');
    this.lastCartNote = ''; // Track the last saved cart note

    console.log('🛒 CartDrawer elements found:', {
      drawer: this.drawer,
      overlay: this.overlay,
      openButton: this.openButton,
      closeButton: this.closeButton,
      cartItems: this.cartItems
    });

    this.bindEvents();
    this.setupQuantityControls();
    this.setupRemoveButtons();
    
    // Initialize cart totals on page load
    this.initializeCart();
  }

  async initializeCart() {
    try {
      console.log('🛒 Initializing cart...');
      const cart = await this.refreshCart();
      
      if (cart && cart.items.length === 0) {
        // Hide checkout buttons if cart is empty on initial load
        this.hideDynamicCheckoutButtons();
      } else if (cart && cart.items.length > 0) {
        // Cart has items, ensure checkout buttons are initialized
        console.log('💳 Cart has items on load, initializing checkout buttons...');
        this.showDynamicCheckoutButtons();
        
        // Initialize payment buttons after a short delay to ensure DOM is ready
        setTimeout(() => {
          this.initializePaymentButtons();
        }, 300);
      }
    } catch (error) {
      console.error('🛒 Error initializing cart:', error);
    }
  }

  bindEvents() {
    // Open cart drawer
    if (this.openButton) {
      this.openButton.addEventListener('click', this.open.bind(this));
    }

    // Close cart drawer
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.close.bind(this));
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', (e) => {
        console.log('🛒 Overlay clicked, closing cart drawer');
        this.close();
      });
    }

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) {
        console.log('🛒 Escape key pressed, closing cart drawer');
        this.close();
      }
    });

    // Close on click outside cart drawer
    document.addEventListener('click', (e) => {
      if (this.isOpen()) {
        // Check if click is outside the cart drawer
        if (!this.drawer.contains(e.target) && !e.target.closest('[data-cart-drawer-toggle]')) {
          console.log('🛒 Clicked outside cart drawer, closing');
          this.close();
        }
      }
    });

    // Handle form submission
    if (this.cartForm) {
      this.cartForm.addEventListener('submit', this.handleFormSubmit.bind(this));
    }
  }

  // setupQuantityControls() {
  //   const quantityButtons = this.querySelectorAll('.quantity__button');
    
  //   quantityButtons.forEach(button => {
  //     button.addEventListener('click', (e) => {
  //       e.preventDefault();
  //       alert('hiiiii');
  //       const input = button.parentElement.querySelector('.quantity__input');
  //       const currentValue = parseInt(input.value);
  //       const isIncrease = button.classList.contains('quantity__button--plus');
        
  //       let newValue = isIncrease ? currentValue + 1 : currentValue - 1;
  //       newValue = Math.max(0, newValue);
        
  //       input.value = newValue;
  //       input.dispatchEvent(new Event('change', { bubbles: true }));
  //     });
  //   });

  //   // Handle quantity input changes
  //   const quantityInputs = this.querySelectorAll('.quantity__input');
  //   quantityInputs.forEach(input => {
  //     input.addEventListener('change', this.updateQuantity.bind(this));
  //   });
  // }



setupQuantityControls() {
  const quantityButtons = this.querySelectorAll('.quantity__button');

  quantityButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();


      const quantityWrapper = button.closest('.quantity');

      if (quantityWrapper.classList.contains('is-locked')) return;


      quantityWrapper.classList.add('is-locked');


      const input = button.parentElement.querySelector('.quantity__input');
      const currentValue = parseInt(input.value, 10) || 0;
      const isIncrease = button.classList.contains('quantity__button--plus');

      let newValue = isIncrease ? currentValue + 1 : currentValue - 1;
      newValue = Math.max(0, newValue);

      input.value = newValue;

    
      input.dispatchEvent(new Event('change', { bubbles: true }));

    });
  });

  // Handle quantity input changes
  const quantityInputs = this.querySelectorAll('.quantity__input');
  quantityInputs.forEach(input => {
    input.addEventListener('change', this.updateQuantity.bind(this));
  });
}


  setupRemoveButtons() {
    const removeButtons = this.querySelectorAll('.cart-drawer__item-remove-button');
    
    removeButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const cartItem = button.closest('.cart-drawer__item');
        const input = cartItem.querySelector('.quantity__input');
        input.value = 0;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  async updateQuantity(event) {
    const input = event.target;
    const quantity = parseInt(input.value);
    const index = input.dataset.index;

    console.log('🛒 Updating quantity:', { index, quantity });

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: index,
          quantity: quantity
        })
      });

      if (response.ok) {
        const updatedCart = await this.refreshCart();
        console.log('🛒 Cart updated after quantity change:', updatedCart?.items?.length || 0, 'items');
        
        // If cart is now empty, ensure we show empty state
        if (updatedCart && updatedCart.items.length === 0) {
          console.log('🛒 Cart is now empty, forcing empty state');
          this.showEmptyState();
        }
      } else {
        throw new Error('Failed to update cart');
      }
    } catch (error) {
      console.error('🛒 Error updating cart:', error);
      // Revert the input value
      input.value = input.dataset.originalValue || 1;
    }
  }

  async handleFormSubmit(event) {
    event.preventDefault();
    
    console.log('🛒 Form submitted, saving cart notes before checkout');
    
    // Get the cart note
    const cartNote = event.target.querySelector('#cart-drawer-note');
    const noteValue = cartNote ? cartNote.value.trim() : '';
    
    console.log('🛒 Cart note value:', noteValue);
    
    try {
      // Save cart note if it has changed
      if (noteValue !== this.lastCartNote) {
        console.log('🛒 Saving cart note...');
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            note: noteValue
          })
        });
        
        if (response.ok) {
          console.log('🛒 Cart note saved successfully');
          this.lastCartNote = noteValue;
        } else {
          console.error('🛒 Failed to save cart note:', response.status);
        }
      }
      
      // Proceed to checkout
      console.log('🛒 Redirecting to checkout...');
      window.location.href = '/checkout';
      
    } catch (error) {
      console.error('🛒 Error saving cart note:', error);
      // Still proceed to checkout even if note saving fails
      window.location.href = '/checkout';
    }
  }

  async handleCartNoteChange(event) {
    const noteValue = event.target.value.trim();
    
    // Debounce the save operation to avoid too many API calls
    clearTimeout(this.noteSaveTimeout);
    this.noteSaveTimeout = setTimeout(async () => {
      if (noteValue !== this.lastCartNote) {
        console.log('🛒 Auto-saving cart note:', noteValue);
        try {
          const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              note: noteValue
            })
          });
          
          if (response.ok) {
            console.log('🛒 Cart note auto-saved successfully');
            this.lastCartNote = noteValue;
          } else {
            console.error('🛒 Failed to auto-save cart note:', response.status);
          }
        } catch (error) {
          console.error('🛒 Error auto-saving cart note:', error);
        }
      }
    }, 1000); // Save after 1 second of inactivity
  }

  async refreshCart() {
    try {
      console.log('🛒 Refreshing cart...');
      
      // Fetch updated cart data
      const response = await fetch('/cart.js', {
        cache: 'no-store',
        headers: { 'Cache-Control': 'no-cache' }
      });
      if (response.ok) {
        const cart = await response.json();
        console.log('🛒 Cart data received:', cart);
        
        // Track the current cart note
        this.lastCartNote = cart.note || '';
        
        // Update cart display and count
        this.updateCartDisplay(cart);
        this.updateCartCount(cart);
        
        console.log('🛒 Cart refresh completed');
        return cart; // Return the cart data for promise chaining
      } else {
        throw new Error(`Failed to fetch cart: ${response.status}`);
      }
    } catch (error) {
      console.error('🛒 Error refreshing cart:', error);
      throw error; // Re-throw for promise rejection
    }
  }

  updateCartDisplay(cart) {
    console.log('🛒 Updating cart display with:', cart.items.length, 'items');
    
    if (cart.items.length === 0) {
      console.log('🛒 Cart is empty, showing empty state');
      this.showEmptyState();
      // Hide dynamic checkout buttons globally when cart is empty
      this.hideDynamicCheckoutButtons();
    } else {
      console.log('🛒 Cart has items, showing cart items');
      this.showCartItems(cart);
      // Ensure totals are updated after showing items
      this.updateTotals(cart);
      // Show dynamic checkout buttons when cart has items
      this.showDynamicCheckoutButtons();
    }
  }

  hideDynamicCheckoutButtons() {
    // Hide all dynamic checkout button wrappers globally
    const allCheckoutWrappers = document.querySelectorAll('.shop-pay-button-wrapper, .dynamic-checkout__content, .cart-drawer__dynamic-checkout');
    allCheckoutWrappers.forEach(wrapper => {
      wrapper.style.display = 'none';
      
      // Hide shopify-accelerated-checkout-cart components
      const checkoutCart = wrapper.querySelector('shopify-accelerated-checkout-cart');
      if (checkoutCart) {
        checkoutCart.style.display = 'none';
      }
      
      // Hide skeleton loaders
      const skeletons = wrapper.querySelectorAll('.wallet-cart-button__skeleton, .shopify-payment-button__skeleton');
      skeletons.forEach(skeleton => {
        skeleton.style.display = 'none';
      });
    });
    
    console.log('💳 Hid all dynamic checkout buttons (cart is empty)');
  }

  showDynamicCheckoutButtons() {
    // Show dynamic checkout buttons in cart drawer only
    const cartDrawerWrapper = this.querySelector('.cart-drawer__dynamic-checkout');
    if (cartDrawerWrapper) {
      cartDrawerWrapper.style.display = 'block';
      cartDrawerWrapper.style.opacity = '1';
      
      // Show shopify-accelerated-checkout-cart component
      const checkoutCart = cartDrawerWrapper.querySelector('shopify-accelerated-checkout-cart');
      if (checkoutCart) {
        checkoutCart.style.display = 'block';
        
        // Hide skeleton loaders if they exist
        const skeletons = checkoutCart.querySelectorAll('.wallet-cart-button__skeleton, .wallet-cart-grid--skeleton');
        skeletons.forEach(skeleton => {
          skeleton.style.display = 'none';
        });
      }
      
      // Initialize payment buttons if Shopify.PaymentButton is available
      if (typeof Shopify !== 'undefined' && Shopify.PaymentButton) {
        try {
          Shopify.PaymentButton.init();
          console.log('💳 Payment buttons initialized');
        } catch (error) {
          console.error('💳 Error initializing payment buttons:', error);
        }
      }
    }
    
    console.log('💳 Showing dynamic checkout buttons (cart has items)');
  }

  showEmptyState() {
    console.log('🛒 Showing empty state');
    
    this.drawer.classList.add('cart-drawer--empty');
    
    // Hide dynamic checkout buttons when cart is empty
    const paymentWrapper = this.querySelector('.cart-drawer__dynamic-checkout');
    if (paymentWrapper) {
      paymentWrapper.style.display = 'none';
      // Also hide any shopify-accelerated-checkout-cart components
      const checkoutComponents = paymentWrapper.querySelectorAll('shopify-accelerated-checkout-cart');
      checkoutComponents.forEach(component => {
        component.style.display = 'none';
      });
    }
    
    // Also hide any dynamic checkout buttons outside the drawer (in case they exist)
    // Only hide if they're inside the cart drawer
    const allCheckoutButtons = document.querySelectorAll('.shop-pay-button-wrapper, .dynamic-checkout__content');
    allCheckoutButtons.forEach(wrapper => {
      // Only hide if it's inside the cart drawer
      if (wrapper.closest('cart-drawer')) {
        wrapper.style.display = 'none';
        const checkoutCart = wrapper.querySelector('shopify-accelerated-checkout-cart');
        if (checkoutCart) {
          checkoutCart.style.display = 'none';
        }
      }
    });
    
    // Get the cart content container and clear it
    const cartContent = this.querySelector('.cart-drawer__content');
    if (cartContent) {
      cartContent.innerHTML = '';
      
      // Create empty state content
      const emptyContent = document.createElement('div');
      emptyContent.className = 'cart-drawer__empty';
      emptyContent.innerHTML = `
        <div class="cart-drawer__empty-content">
          <h3 class="cart-drawer__empty-heading">Your cart is empty</h3>
          <p class="cart-drawer__empty-text">Continue browsing to add items to your cart</p>
          <a href="/collections/all" class="button button--primary">
            Continue Shopping
          </a>
        </div>
      `;
      
      cartContent.appendChild(emptyContent);
      console.log('🛒 Empty state displayed with continue shopping button');
    }
  }

  showCartItems(cart) {
    console.log('🛒 Showing cart items:', cart.items.length);
    
    this.drawer.classList.remove('cart-drawer--empty');
    
    // Get the cart content container
    const cartContent = this.querySelector('.cart-drawer__content');
    if (!cartContent) {
      console.error('🛒 Cart content container not found');
      return;
    }
    
    // Clear any existing content (empty state or previous cart items)
    cartContent.innerHTML = '';
    
    // Create the complete cart form structure
    const cartForm = document.createElement('form');
    cartForm.className = 'cart-drawer__form';
    cartForm.setAttribute('action', '/cart');
    cartForm.setAttribute('method', 'post');
    cartForm.setAttribute('novalidate', '');
    
    // Create cart items container
    const cartItemsContainer = document.createElement('div');
    cartItemsContainer.id = 'cart-drawer-items';
    cartItemsContainer.className = 'cart-drawer__items';
    
    // Populate cart items
    cartItemsContainer.innerHTML = cart.items.map((item, index) => this.renderCartItem(item, index + 1)).join('');
    
    // Create footer with all necessary elements
    const footer = document.createElement('div');
    footer.className = 'cart-drawer__footer';
    footer.innerHTML = `
      <!-- You May Also Like Section -->
      <div class="cart-drawer__recommendations" style="display: none;">
        <!-- Recommendations will be populated if available -->
      </div>
      
      <div class="cart-drawer__note">
        <label for="cart-drawer-note">Order special instructions</label>
        <textarea
          class="cart-drawer__note-textarea"
          name="note"
          id="cart-drawer-note"
          placeholder="Add a note to your order..."
        >${cart.note || ''}</textarea>
      </div>

      <div class="cart-drawer__totals">
        <div class="cart-drawer__subtotal">
          <span class="cart-drawer__subtotal-label">Subtotal</span>
          <span class="cart-drawer__subtotal-price">${this.formatMoney(cart.total_price).replace(/\.00$/, '')}</span>
        </div>

        <div class="cart-drawer__taxes">
          <p class="cart-drawer__taxes-note">
            Taxes and shipping calculated at checkout.
          </p>
        </div>

        <div class="cart-drawer__checkout">
          <div class="cart-drawer__shipping-message">
            You Qualify for Free Shipping Now!
          </div>
          <button type="submit" class="cart-drawer__checkout-button button button--primary" name="add" aria-haspopup="dialog">
            CHECKOUT - ${this.formatMoney(cart.total_price).replace(/\.00$/, '')}
          </button>
          
          <!-- Dynamic Checkout Buttons -->
          <div class="cart-drawer__dynamic-checkout">
            <!-- Dynamic checkout buttons will be loaded here -->
          </div>
        </div>
      </div>
    `;
    
    // Assemble the form
    cartForm.appendChild(cartItemsContainer);
    cartForm.appendChild(footer);
    
    // Add form to cart content
    cartContent.appendChild(cartForm);
    
    // Store references
    this.cartForm = cartForm;
    this.cartItems = cartItemsContainer;
    
    // Bind submit handler
    this.cartForm.addEventListener('submit', this.handleFormSubmit.bind(this));
    
    // Bind cart note change handler for real-time saving
    const cartNoteTextarea = footer.querySelector('#cart-drawer-note');
    if (cartNoteTextarea) {
      cartNoteTextarea.addEventListener('input', this.handleCartNoteChange.bind(this));
    }
    
    console.log('🛒 Created complete cart structure with checkout button');
    
    // Verify the button was created
    const checkoutButton = footer.querySelector('.cart-drawer__checkout-button');
    console.log('🛒 Checkout button created:', checkoutButton);
    
    // Re-setup event listeners for new items
    this.setupQuantityControls();
    this.setupRemoveButtons();
    
    // Load and initialize payment buttons in cart drawer
    this.loadDynamicCheckoutButtons();
  }

  async loadDynamicCheckoutButtons() {
    const paymentWrapper = this.querySelector('.cart-drawer__dynamic-checkout');
    if (!paymentWrapper) {
      console.log('💳 No payment wrapper found, skipping checkout buttons load');
      return;
    }

    try {
      // Fetch the cart page which should have the checkout buttons
      const response = await fetch('/cart');
      if (!response.ok) {
        throw new Error('Failed to fetch cart');
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Look for checkout buttons in the cart page
      // They might be in a form or in a specific container
      let checkoutButtons = doc.querySelector('#dynamic-checkout-cart, .dynamic-checkout__content');
      
      // If not found, try to find shopify-accelerated-checkout-cart component
      if (!checkoutButtons) {
        checkoutButtons = doc.querySelector('shopify-accelerated-checkout-cart');
      }
      
      // If still not found, look for the wrapper
      if (!checkoutButtons) {
        const wrapper = doc.querySelector('.shop-pay-button-wrapper, .cart-drawer__dynamic-checkout');
        if (wrapper) {
          checkoutButtons = wrapper.querySelector('shopify-accelerated-checkout-cart, #dynamic-checkout-cart, .dynamic-checkout__content') || wrapper;
        }
      }
      
      if (checkoutButtons && checkoutButtons.innerHTML.trim()) {
        // Get the inner HTML or outer HTML depending on what we found
        const buttonsHTML = checkoutButtons.tagName === 'SHOPIFY-ACCELERATED-CHECKOUT-CART' 
          ? checkoutButtons.outerHTML 
          : checkoutButtons.innerHTML;
        
        paymentWrapper.innerHTML = buttonsHTML;
        console.log('💳 Loaded dynamic checkout buttons HTML');
        
        // Wait a bit for the web component to initialize
        setTimeout(() => {
          this.initializePaymentButtons();
        }, 200);
      } else {
        console.log('💳 No checkout buttons found, hiding wrapper');
        paymentWrapper.style.display = 'none';
      }
    } catch (error) {
      console.error('💳 Error loading checkout buttons:', error);
      paymentWrapper.style.display = 'none';
    }
  }

  renderCartItem(item, index) {
    const image = item.image ? 
      `<img src="${item.image}" alt="${item.image.alt || item.title}" class="cart-drawer__item-image-img" width="150" height="150" loading="lazy">` : 
      '';

    const variantTitle = '';

    return `
      <div class="cart-drawer__item" id="cart-drawer-item-${index}">
        <div class="cart-drawer__item-image">
          ${image}
        </div>
        <div class="cart-drawer__item-details">
          <h3 class="cart-drawer__item-title">
            <a href="${item.url}" class="cart-drawer__item-link">${item.title}</a>
          </h3>
          <div class="cart-drawer__item-price">
            ${item.original_price !== item.final_price ? 
              `<s class="cart-drawer__item-price-regular">${this.formatMoney(item.original_price).replace(/\.00$/, '')}</s>
               <strong class="cart-drawer__item-price-final">${this.formatMoney(item.final_price).replace(/\.00$/, '')}</strong>` :
              this.formatMoney(item.original_price).replace(/\.00$/, '')
            }
          </div>
          ${variantTitle}
          <div class="cart-drawer__item-quantity">
            <div class="quantity">
              <button class="quantity__button quantity__button--minus" type="button" name="minus">
                <svg class="icon icon-minus" viewBox="0 0 10 2">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.8.5 1 .5h8c.3 0 .5.2.5.5s-.2.5-.5.5H1C.8 2 .5 1.8.5 1z" fill="currentColor">
                </svg>
              </button>
              <input class="quantity__input" type="number" name="updates[]" value="${item.quantity}" min="0" data-index="${index}">
              <button class="quantity__button quantity__button--plus" type="button" name="plus">
                <svg class="icon icon-plus" viewBox="0 0 10 10">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49 1a.5.5 0 00-1 .01v3.5L1 4.51z" fill="currentColor">
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div class="cart-drawer__item-remove">
          <button type="button" class="cart-drawer__item-remove-button">
            <svg class="icon icon-remove" viewBox="0 0 18 17">
              <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
            </svg>
          </button>
        </div>
      </div>
    `;
  }

  updateTotals(cart) {
    console.log('🛒 updateTotals called with cart:', cart);
    console.log('🛒 cart.total_price:', cart.total_price);
    
    const subtotalElement = this.querySelector('.cart-drawer__subtotal-price');
    if (subtotalElement) {
      subtotalElement.textContent = this.formatMoney(cart.total_price).replace(/\.00$/, '');
      console.log('🛒 Updated subtotal to:', this.formatMoney(cart.total_price));
    }
    
    // Update checkout button price
    const checkoutButton = this.querySelector('.cart-drawer__checkout-button');
    console.log('🛒 Found checkout button:', checkoutButton);
    if (checkoutButton) {
      const formattedPrice = this.formatMoney(cart.total_price).replace(/\.00$/, '');
      const newText = `CHECKOUT - ${formattedPrice}`;
      checkoutButton.textContent = newText;
      console.log('🛒 Updated checkout button to:', newText);
    } else {
      console.log('🛒 Checkout button not found!');
    }
  }

  updateCartCount(cart) {
    const cartCountElements = document.querySelectorAll('.cart-count, [data-cart-count]');
    cartCountElements.forEach(element => {
      element.textContent = cart.item_count;
    });
  }

  formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(cents / 100);
  }

  async open() {
    console.log('🛒 CartDrawer.open() called');
    console.log('🛒 Drawer element:', this.drawer);
    console.log('🛒 Adding cart-drawer--open class');
    
    this.drawer.classList.add('cart-drawer--open');
    document.body.classList.add('cart-drawer-open');
    
    console.log('🛒 Classes added, drawer should be visible now');
    
    // Refresh cart data when opening
    try {
      const cart = await this.refreshCart();
      console.log('🛒 Cart refreshed on open, items:', cart?.items?.length || 0);
      
      // If cart has items, ensure all elements are properly displayed
      if (cart && cart.items.length > 0) {
        console.log('🛒 Cart has items, ensuring proper display');
        // Force a re-render to ensure all elements are visible
        setTimeout(() => {
          this.showCartItems(cart);
          this.updateTotals(cart);
        }, 100);
      }
    } catch (error) {
      console.error('🛒 Error refreshing cart on open:', error);
    }
    
    // Initialize payment buttons after cart is refreshed
    setTimeout(() => {
      this.initializePaymentButtons();
    }, 300);
    
    // Focus first focusable element
    const firstFocusable = this.drawer.querySelector('button, input, a');
    if (firstFocusable) {
      firstFocusable.focus();
    }
  }

  initializePaymentButtons() {
    console.log('💳 Initializing payment buttons in cart drawer...');
    
    // First check if cart is empty - don't initialize if empty
    const cartContent = this.querySelector('.cart-drawer__content');
    const isEmpty = this.drawer.classList.contains('cart-drawer--empty') || 
                    !cartContent || 
                    cartContent.querySelector('.cart-drawer__empty');
    
    if (isEmpty) {
      console.log('💳 Cart is empty, skipping payment button initialization');
      // Hide any existing payment buttons
      const paymentWrapper = this.querySelector('.cart-drawer__dynamic-checkout');
      if (paymentWrapper) {
        paymentWrapper.style.display = 'none';
      }
      return;
    }
    
    const paymentWrapper = this.querySelector('.cart-drawer__dynamic-checkout');
    if (!paymentWrapper) {
      console.log('💳 No payment wrapper found in cart drawer');
      return;
    }
    
    // Ensure wrapper is visible only if cart has items
    paymentWrapper.style.display = 'block';
    paymentWrapper.style.opacity = '1';
    
    // Remove any skeleton loaders that might be stuck
    const skeletons = paymentWrapper.querySelectorAll('.shopify-payment-button__skeleton, .wallet-cart-button__skeleton');
    skeletons.forEach(skeleton => {
      skeleton.style.display = 'none';
      console.log('💳 Removed cart drawer payment button skeleton');
    });
    
    // Hide skeleton loaders in shopify-accelerated-checkout-cart component
    const checkoutCart = paymentWrapper.querySelector('shopify-accelerated-checkout-cart');
    if (checkoutCart) {
      const walletSkeletons = checkoutCart.querySelectorAll('.wallet-cart-button__skeleton');
      walletSkeletons.forEach(skeleton => {
        skeleton.style.display = 'none';
      });
      
      // Ensure the component itself is visible
      checkoutCart.style.display = 'block';
    }
    
    // Initialize Shopify payment buttons if available
    if (typeof Shopify !== 'undefined' && Shopify.PaymentButton) {
      try {
        console.log('💳 Calling Shopify.PaymentButton.init() for cart drawer');
        Shopify.PaymentButton.init();
        console.log('✅ Cart drawer payment buttons initialized');
      } catch (error) {
        console.error('❌ Error initializing cart drawer payment buttons:', error);
      }
    } else {
      console.log('💳 Shopify.PaymentButton not available, will try again...');
      // Try again after a delay
      setTimeout(() => this.initializePaymentButtons(), 500);
    }
  }

  close() {
    console.log('🛒 CartDrawer.close() called');
    this.drawer.classList.remove('cart-drawer--open');
    document.body.classList.remove('cart-drawer-open');
    console.log('🛒 Cart drawer closed');
  }

  isOpen() {
    return this.drawer.classList.contains('cart-drawer--open');
  }

  connectedCallback() {
    // Called when the element is inserted into the DOM
    console.log('🛒 Cart drawer connected to DOM');
    
    // Initialize checkout buttons if cart has items and buttons are already rendered
    setTimeout(() => {
      const paymentWrapper = this.querySelector('.cart-drawer__dynamic-checkout');
      if (paymentWrapper && paymentWrapper.querySelector('shopify-accelerated-checkout-cart')) {
        // Check if cart has items
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            if (cart && cart.items.length > 0) {
              console.log('💳 Initializing checkout buttons on connect (cart has items)');
              this.showDynamicCheckoutButtons();
              this.initializePaymentButtons();
            }
          })
          .catch(error => {
            console.error('💳 Error checking cart on connect:', error);
          });
      }
    }, 100);
  }
}

customElements.define('cart-drawer', CartDrawer);
